import styled from "styled-components";

export const SectionTitleComponent = styled.h5`
  ${(p) => p.theme.tipography.h5}
  margin-bottom: 16px;
`;
